module.exports = __webpack_public_path__ + "static/stephenKingGif-6be229e9de32371c2c6ad6faefa5b466.gif";